import React, { useState, useEffect } from 'react';
import { Card, Table, Button, Form, Spinner, Modal } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { Get as baseGet, Put } from '@app/utils/httpProvider';
import { ACCOUNT_API, ACCOUNT_AUTHINFO_API, BaseGatewayImage, CHUNGCHI_CHUYENMON_API, DANHSACH_DUYET_HOSO_API, DONVI_API, DOITUONG_API } from '@app/utils/apiUrl';
import { getUser } from '@app/utils/oidc';
import { toast } from 'react-toastify';
import { useQueryClient } from 'react-query';
import { getRoleUser } from '@app/utils/httpClient';
import { role } from '@app/utils/define';
import Select from 'react-select';

// Hàm wrapper Get để tự động bypass cache trình duyệt cho tất cả các cuộc gọi API GET trên trang này
const Get = (api, param = null, model = null) => {
    const cleanModel = model ? { ...model, _t: Date.now() } : { _t: Date.now() };
    return baseGet(api, param, cleanModel);
};

// HÀM HỖ TRỢ HIỂN THỊ TÊN VIẾT TẮT CHO NHÃN
const getShortLoaiChungChi = (name) => {
    if (!name) return "";
    const lowerName = name.toLowerCase().trim();
    if (lowerName === "chứng chỉ kỹ thuật chuyên môn về khám bệnh, chữa bệnh") {
        return "CCKTCMKB-CB";
    }
    if (lowerName === "chứng chỉ chuyên môn kỹ thuật dưới 09 tháng" || lowerName === "chứng chỉ chuyên môn kỹ thuật dưới 9 tháng") {
        return "CCCMKT<9T";
    }
    if (lowerName === "chứng chỉ chuyên khoa trên 09 tháng" || lowerName === "chứng chỉ chuyên môn kỹ thuật trên 9 tháng") {
        return "CCCK>9T";
    }
    return name;
};

const renderStatusBadge = (status, type = 'duyet') => {
    if (status === true) {
        return (
            <span className="badge bg-success p-2 fw-normal" style={{ fontSize: '13px', display: 'inline-flex', alignItems: 'center', minWidth: '95px', justifyContent: 'center' }}>
                <i className="fas fa-check-circle me-1"></i> {type === 'duyet' ? 'Đã duyệt' : 'Phù hợp'}
            </span>
        );
    }
    if (status === false) {
        return (
            <span className="badge bg-danger p-2 fw-normal" style={{ fontSize: '13px', display: 'inline-flex', alignItems: 'center', minWidth: '95px', justifyContent: 'center' }}>
                <i className="fas fa-times-circle me-1"></i> {type === 'duyet' ? 'Từ chối' : 'Không phù hợp'}
            </span>
        );
    }
    return (
        <span className="badge bg-secondary p-2 fw-normal" style={{ fontSize: '12px', display: 'inline-flex', alignItems: 'center', minWidth: '95px', justifyContent: 'center' }}>
            Chưa {type === 'duyet' ? 'duyệt' : 'xác nhận'}
        </span>
    );
};

// MẢNG LÝ DO TỪ CHỐI
const REJECT_REASONS = [
    { value: 'Chứng chỉ hành nghề không phù hợp', label: 'Chứng chỉ hành nghề không phù hợp' },
    { value: 'Văn bằng chứng chỉ chuyên khoa không phù hợp', label: 'Văn bằng chứng chỉ chuyên khoa không phù hợp' },
    { value: 'Khác', label: 'Khác' }
];

const DanhSachDuyetHoSoKHTH = () => {
    const [userRole, setUserRole] = useState([]);
    const [isLoading, setIsLoading] = useState(true);



    const queryClient = useQueryClient();

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [pendingAction, setPendingAction] = useState(null);

    const [hoSoModal, setHoSoModal] = useState({ show: false, itemId: null, status: null, reason: '' });
    const [rejectModal, setRejectModal] = useState({ show: false, itemId: null, reason: '', customReason: '' });

    const [danhSach, setDanhSach] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);

    const [currentPage, setCurrentPage] = useState(() => {
        const savedPage = sessionStorage.getItem('khth_page');
        return savedPage ? parseInt(savedPage, 10) : 1;
    });

    useEffect(() => {
        sessionStorage.setItem('khth_page', currentPage);
    }, [currentPage]);
    const [itemsPerPage, setItemsPerPage] = useState(5);

    const [searchCccdInput, setSearchCccdInput] = useState('');
    const [searchCccd, setSearchCccd] = useState('');
    const [searchNameInput, setSearchNameInput] = useState('');
    const [searchName, setSearchName] = useState('');
    const [filterXacNhan, setFilterXacNhan] = useState('all');
    const [filterDonVi, setFilterDonVi] = useState('');
    const [filterDoiTuong, setFilterDoiTuong] = useState('');
    const [danhSachDonVi, setDanhSachDonVi] = useState([]);
    const [danhSachDoiTuong, setDanhSachDoiTuong] = useState([]);

    useEffect(() => {
        const fetchDonVi = async () => {
            try {
                const res = await Get(DONVI_API.GET_PAGING, null, { PageSize: 10000 });
                const list = Array.isArray(res) ? res : (res?.data || res?.data?.$values || []);
                setDanhSachDonVi(list);
            } catch (err) {
                console.error("Lỗi fetch danh sách đơn vị:", err);
            }
        };
        const fetchDoiTuong = async () => {
            try {
                const res = await Get(DOITUONG_API.GET_PAGING, null, { PageSize: 10000 });
                const list = Array.isArray(res) ? res : (res?.data || res?.data?.$values || []);
                setDanhSachDoiTuong(list);
            } catch (err) {
                console.error("Lỗi fetch danh sách đối tượng:", err);
            }
        };
        fetchDonVi();
        fetchDoiTuong();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const roles = await getRoleUser();

                let normalizedRoles = [];
                if (typeof roles === 'string') {
                    normalizedRoles = [roles.toLowerCase()];
                } else if (Array.isArray(roles)) {
                    normalizedRoles = roles.map(r => r.toLowerCase());
                }
                setUserRole(normalizedRoles);

                const checkAdmin = normalizedRoles.includes(role.Admin);
                const checkBaseAccess = normalizedRoles.includes(role.APP_DANHSACHDUYETHOSO_ACCESS);
                const checkHldt = normalizedRoles.includes(role.HLDT_NHAN_VIEN);
                const checkKhth = normalizedRoles.includes(role.PHONG_KE_HOACH_TONG_HOP);



                const user = await getUser();
                if (!user?.profile?.sub) {
                    setIsLoading(false);
                    return;
                }

                try {
                    let apiParams = { PageIndex: currentPage, PageSize: itemsPerPage };
                    if (filterDonVi || filterDoiTuong || searchName) {
                        apiParams = { PageIndex: 1, PageSize: 1000000 };
                    }

                    // Truyền filter XacNhanDuyet xuống API (lọc dưới DB)
                    if (filterXacNhan && filterXacNhan !== 'all') {
                        const xacNhanMap = {
                            'phu_hop': 'PhuHop',
                            'khong_phu_hop': 'KhongPhuHop',
                            'chua_xac_nhan': 'ChuaXacNhan'
                        };
                        apiParams.XacNhanDuyet = xacNhanMap[filterXacNhan] || '';
                    }
                    if (searchCccd) {
                        try {
                            const authRes = await Get(`${ACCOUNT_AUTHINFO_API.GET_BY_USERNAME}/${searchCccd}`);
                            const authData = authRes?.data || authRes;
                            const accountIdToSearch = authData?.accountId || authData?.AccountId;
                            if (!accountIdToSearch) {
                                setDanhSach([]);
                                setTotalRecords(0);
                                setIsLoading(false);
                                return;
                            }
                            apiParams.AccountId = accountIdToSearch;
                        } catch (e) {
                            console.error('Lỗi lấy account id theo cccd:', e);
                            setDanhSach([]);
                            setTotalRecords(0);
                            setIsLoading(false);
                            return;
                        }
                    }

                    if (searchName) {
                        try {
                            const accountsRes = await Get(ACCOUNT_AUTHINFO_API.GET_PAGING, null, { keyword: searchName, email: "", pageIndex: 1, pageSize: 1000000 });
                            const accountsData = accountsRes?.data || accountsRes;
                            const matchedAccounts = accountsData?.data || accountsData?.$values || (Array.isArray(accountsData) ? accountsData : []);

                            const matchedIds = matchedAccounts.map(acc => acc.accountId || acc.AccountId).filter(Boolean);

                            if (matchedIds.length === 0) {
                                setDanhSach([]);
                                setTotalRecords(0);
                                setIsLoading(false);
                                return;
                            }
                            apiParams.AccountIds = matchedIds;
                        } catch (e) {
                            console.error('Lỗi lấy danh sách account theo tên:', e);
                            setDanhSach([]);
                            setTotalRecords(0);
                            setIsLoading(false);
                            return;
                        }
                    }
                    const resPaging = await Get(DANHSACH_DUYET_HOSO_API.GET_ALL_BY_PAGING_GIAYPHEPHANHNGHE, null, apiParams);

                    let listGiayPhepHanhNghes = resPaging?.data?.$values || resPaging?.data || resPaging || [];

                    listGiayPhepHanhNghes = listGiayPhepHanhNghes.filter(item => {
                        const statusStr = String(item.trangThai || item.TrangThai || '').toLowerCase().trim();
                        return statusStr !== '0' && statusStr !== 'nhaplieu' && statusStr !== 'nhập liệu';
                    });

                    if ((filterDonVi || filterDoiTuong) && listGiayPhepHanhNghes.length > 0) {
                        const accDonViMap = {};
                        const accDoiTuongMap = {};

                        try {
                            // TÌM DonViId và DoiTuongId từ danh sách options để truyền xuống API lọc
                            let selectedDonViId = null;
                            if (filterDonVi && Array.isArray(danhSachDonVi)) {
                                const foundDonVi = danhSachDonVi.find(d => (d.tenDonVi || d.TenDonVi) === filterDonVi);
                                if (foundDonVi) selectedDonViId = foundDonVi.id || foundDonVi.Id;
                            }

                            let selectedDoiTuongId = null;
                            if (filterDoiTuong && Array.isArray(danhSachDoiTuong)) {
                                const foundDt = danhSachDoiTuong.find(d => (d.tenDoiTuong || d.TenDoiTuong) === filterDoiTuong);
                                if (foundDt) selectedDoiTuongId = foundDt.id || foundDt.Id;
                            }

                            const payload = { 
                                Keyword: "",
                                DonViId: selectedDonViId || "",
                                ChucDanhChuyenMonId: "",
                                DoiTuongId: selectedDoiTuongId || "",
                                PageIndex: 1,
                                PageSize: 1000000 
                            };

                            // Gọi 1 lần lấy AccountInfo theo bộ lọc
                            const allRes = await Get(ACCOUNT_API.GET_PAGING_ACCOUNT_FROM_APP_DUNGCHUNG, null, payload);
                            const allList = allRes?.data?.$values || allRes?.data || allRes || [];

                            if (Array.isArray(allList)) {
                                allList.forEach(info => {
                                    const accId = info?.accountId || info?.AccountId;
                                    if (!accId) return;
                                    const donVis = info?.donVis || info?.DonVis?.$values || info?.DonVis || [];
                                    const tenDonVi = (Array.isArray(donVis) && donVis[0]) ? (donVis[0].tenDonVi || donVis[0].TenDonVi) : 'Chưa có đơn vị';
                                    accDonViMap[accId] = tenDonVi;
                                    accDoiTuongMap[accId] = info?.doiTuong?.tenDoiTuong || info?.DoiTuong?.TenDoiTuong || '';
                                });
                            }
                        } catch (e) {
                            console.error('[Filter] Lỗi khi lấy danh sách AccountInfo:', e);
                        }

                        listGiayPhepHanhNghes = listGiayPhepHanhNghes.filter(item => {
                            let match = true;
                            const donVi = accDonViMap[item.accountId] || 'Chưa có đơn vị';
                            const doiTuong = accDoiTuongMap[item.accountId] || '';

                            if (filterDonVi) match = match && donVi === filterDonVi;
                            if (filterDoiTuong) match = match && doiTuong === filterDoiTuong;
                            return match;
                        });
                    }

                    setTotalRecords((filterDonVi || filterDoiTuong || searchName) ? listGiayPhepHanhNghes.length : (resPaging?.totalRecords || listGiayPhepHanhNghes.length || 0));

                    if (filterDonVi || filterDoiTuong || searchName) {
                        listGiayPhepHanhNghes = listGiayPhepHanhNghes.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
                    }

                    if (!listGiayPhepHanhNghes || !Array.isArray(listGiayPhepHanhNghes) || listGiayPhepHanhNghes.length === 0) {
                        setDanhSach([]);
                        return;
                    }

                    const parseTrangThai = (trangThaiValue) => {
                        if (trangThaiValue === null || trangThaiValue === undefined) return null;

                        if (typeof trangThaiValue === 'number') {
                            if (trangThaiValue === 1) return true;
                            if (trangThaiValue === 2) return false;
                            return null;
                        }

                        const text = trangThaiValue.toString().trim().toLowerCase();
                        if (text === "đã duyệt" || text === "da duyet" || text === "1") return true;
                        if (text === "từ chối" || text === "tu choi" || text === "2") return false;

                        return null;
                    };

                    const formattedData = await Promise.all(listGiayPhepHanhNghes.map(async (item) => {
                        let hoTen = "Chưa cập nhật";
                        let tenDoiTuong = "Chưa cập nhật";
                        let chucDanhChuyenMon = "Chưa cập nhật";
                        let tenDonVi = "Chưa cập nhật";

                        if (item.accountId) {
                            const [account, doiTuongInfo] = await Promise.all([
                                Get(`${ACCOUNT_API.GET_ACCOUNT_BYID_FROM_APP_DUNGCHUNG}/${item.accountId}`),
                                Get(`${ACCOUNT_API.GET_ACCOUNT_INFO_BYID_FROM_APP_DUNGCHUNG}/${item.accountId}`)
                            ]);

                            hoTen = [account?.lastName, account?.middleName, account?.firstName]
                                .filter(Boolean)
                                .join(' ');

                            tenDoiTuong = doiTuongInfo?.doiTuong?.tenDoiTuong || tenDoiTuong;
                            chucDanhChuyenMon = doiTuongInfo?.chucDanhChuyenMon?.tenDoiTuong || chucDanhChuyenMon;
                            tenDonVi = doiTuongInfo?.donVis?.[0]?.tenDonVi || tenDonVi;
                        }

                        const listChungChiChuyenMons = await Get(`${CHUNGCHI_CHUYENMON_API.GET_BY_ACCOUNT_INFO_ID}/${item.accountId}`);
                        const safeListCCCM = Array.isArray(listChungChiChuyenMons) ? listChungChiChuyenMons : [];

                        const mapCert = cert => ({
                            idCccm: cert.id,
                            loaiCccm: cert.loaiChungChi || cert.tenLoaiChungChi || cert.LoaiChungChi || cert.phanLoai || "",
                            tenCccm: cert.tenChungChi || "Chưa rõ tên CC",
                            ghiChu: cert.ghiChu || cert.GhiChu || "",
                            fileUrl: cert.fileMinhChungPath || "",
                            status: parseTrangThai(cert.trangThai)
                        });

                        const cccmKHTH = safeListCCCM.map(mapCert);
                        // const cccmHLDT = safeListCCCM.map(mapCert);

                        let initialXacNhanStatus = null;
                        try {
                            const duyetRes = await Get(`${DANHSACH_DUYET_HOSO_API.GET_BY_GIAYPHEP_ID}/${item.id}`);
                            const duyetData = duyetRes?.data || duyetRes;
                            const xacNhanText = duyetData?.xacNhanDuyet || duyetData?.XacNhanDuyet;

                            if (xacNhanText === "Phù hợp") {
                                initialXacNhanStatus = true;
                            } else if (xacNhanText === "Không phù hợp") {
                                initialXacNhanStatus = false;
                            }
                        } catch (error) {
                        }

                        let pvhnList = [];
                        if (Array.isArray(item.phamViHanhNgheNames) && item.phamViHanhNgheNames.length > 0) {
                            pvhnList = item.phamViHanhNgheNames;
                        } else if (Array.isArray(item.PhamViHanhNgheNames) && item.PhamViHanhNgheNames.length > 0) {
                            pvhnList = item.PhamViHanhNgheNames;
                        } else {
                            const fallbackPvhn = item.tenPhamViHanhNghe || item.TenPhamViHanhNghe || item.phamViHanhNghe || item.PhamViHanhNghe;
                            if (Array.isArray(fallbackPvhn)) {
                                pvhnList = fallbackPvhn;
                            } else if (typeof fallbackPvhn === 'string') {
                                pvhnList = [fallbackPvhn];
                            }
                        }

                        const ngayHetHanCchn = item.ngayHetHan || item.NgayHetHan || item.thoiHan || item.ThoiHan;

                        return {
                            id: item.id,
                            ten: hoTen,
                            chucDanhChuyenMon: chucDanhChuyenMon,
                            doiTuong: tenDoiTuong, // Chức danh đang hoạt động
                            donVi: tenDonVi,
                            phamViHanhNghe: pvhnList,
                            cchn: item.soGiayPhep || "Chưa cập nhật",
                            fileUrl: item.fileMinhChungPath || "",
                            moTaCchn: ngayHetHanCchn ? [`Ngày hết hạn: ${new Date(ngayHetHanCchn).toLocaleDateString('vi-VN')}`] : [],
                            cchnStatus: parseTrangThai(item.trangThai),
                            // cccmHLDT: cccmHLDT,
                            cccmKHTH: cccmKHTH,
                            xacNhanStatus: initialXacNhanStatus,
                            trangThai: item.trangThaiHoSo ?? 0
                        };
                    }));

                    setDanhSach(formattedData);

                } catch (error) {
                    console.error('Lỗi khi lấy thông tin hồ sơ tổng hợp:', error);
                }
            } catch (error) {
                console.error('Không thể kết nối đến hệ thống xác thực:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [currentPage, itemsPerPage, filterDonVi, filterDoiTuong, searchCccd, searchName, filterXacNhan]);

    const donViOptions = React.useMemo(() => {
        const list = Array.isArray(danhSachDonVi) ? danhSachDonVi : [];
        return list.map(item => {
            const ten = item.tenDonVi || item.TenDonVi;
            return ten ? { value: ten, label: ten } : null;
        }).filter(Boolean).sort((a, b) => a.label.localeCompare(b.label, 'vi'));
    }, [danhSachDonVi]);

    const doiTuongOptions = React.useMemo(() => {
        const list = Array.isArray(danhSachDoiTuong) ? danhSachDoiTuong : [];
        return list.map(item => {
            const ten = item.tenDoiTuong || item.TenDoiTuong;
            return ten ? { value: ten, label: ten } : null;
        }).filter(Boolean);
    }, [danhSachDoiTuong]);

    const uniqueDoiTuong = [...new Set(danhSach.map(item => item.doiTuong).filter(val => val && val !== "Chưa cập nhật"))].sort();

    // XacNhanDuyet đã được lọc dưới DB, không cần lọc FE nữa
    const filteredDanhSach = danhSach;

    const currentItems = filteredDanhSach;
    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = indexOfFirstItem + currentItems.length;
    const totalPages = Math.ceil(totalRecords / itemsPerPage);

    const handleItemsPerPageChange = (e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); };
    const handleFilterXacNhanChange = (e) => { setFilterXacNhan(e.target.value); setCurrentPage(1); };
    const handleFilterDoiTuongChange = (e) => { setFilterDoiTuong(e.target.value); setCurrentPage(1); };
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleViewFile = async (fileUrl, e) => {
        e.preventDefault();
        if (!fileUrl) return;
        try {
            const BACKEND_DOMAIN = BaseGatewayImage;
            const fullUrl = fileUrl.startsWith('http') ? fileUrl : `${BACKEND_DOMAIN}${fileUrl}`;
            window.open(fullUrl, '_blank');
        } catch (error) {
            console.error('Lỗi khi tải file đính kèm:', error);
            alert('Không thể tải file.');
        }
    };

    const executeVerifyCchn = (id, status) => {
        const updatedList = danhSach.map(item => item.id === id ? { ...item, cchnStatus: status } : item);
        setDanhSach(updatedList);
    };

    const executeVerifyCccm = (userId, cccmId, status) => {
        const updatedList = danhSach.map(user => {
            if (user.id === userId) {
                // const updatedHLDT = user.cccmHLDT.map(cert => cert.idCccm === cccmId ? { ...cert, status: status } : cert);
                const updatedKHTH = user.cccmKHTH.map(cert => cert.idCccm === cccmId ? { ...cert, status: status } : cert);
                return { ...user, /* cccmHLDT: updatedHLDT, */ cccmKHTH: updatedKHTH };
            }
            return user;
        });
        setDanhSach(updatedList);
    };

    const executeXacNhanPhuHop = (id, status) => {
        const updatedList = danhSach.map(item => item.id === id ? { ...item, xacNhanStatus: status } : item);
        setDanhSach(updatedList);
    };

    const openConfirmModal = (type, itemId, certId, status) => {
        setPendingAction({ type, itemId, certId, status });
        setShowConfirmModal(true);
    };

    const handleConfirmAction = async () => {
        if (!pendingAction) return;

        const { type, itemId, certId, status } = pendingAction;
        const payload = {
            fieldName: 'TrangThai',
            value: status ? "Đã duyệt" : "Từ chối"
        };

        try {
            if (type === 'CCHN') {
                payload.id = itemId;
                await Put(`${DANHSACH_DUYET_HOSO_API.UPDATE_FIELD_GPHN}`, null, payload);
                executeVerifyCchn(itemId, status);
            } else if (type === 'CCCM') {
                payload.id = certId;
                await Put(`${CHUNGCHI_CHUYENMON_API.UPDATE_FIELD}`, null, payload);
                executeVerifyCccm(itemId, certId, status);
            } else if (type === 'HOSO') {
                executeXacNhanPhuHop(itemId, status);
            }

            setShowConfirmModal(false);
            setPendingAction(null);
            queryClient.invalidateQueries(['giayPhepHanhNgheProfile']);

        } catch (error) {
            console.error("Lỗi:", error);
            alert("Có lỗi xảy ra khi lưu trạng thái lên máy chủ. Vui lòng thử lại!");
        }
    };

    const getConfirmMessage = () => {
        if (!pendingAction) return '';
        const { type, status } = pendingAction;
        if (type === 'CCHN') return status ? 'Xác nhận DUYỆT chứng chỉ hành nghề này?' : 'Xác nhận KHÔNG DUYỆT chứng chỉ hành nghề này?';
        if (type === 'CCCM') return status ? 'Xác nhận DUYỆT chứng chỉ chuyên môn này?' : 'Xác nhận KHÔNG DUYỆT chứng chỉ chuyên môn này?';
        if (type === 'HOSO') return status ? 'Xác nhận toàn bộ hồ sơ này là PHÙ HỢP?' : 'Xác nhận toàn bộ hồ sơ này là KHÔNG PHÙ HỢP?';
        return 'Xác nhận?';
    };

    const xacNhanHoSoConfirm = async () => {
        if (!hoSoModal.itemId) return;
        const { itemId, status, reason } = hoSoModal;

        try {
            const duyetRes = await Get(`${DANHSACH_DUYET_HOSO_API.GET_BY_GIAYPHEP_ID}/${itemId}`);
            const duyetData = duyetRes?.data || duyetRes;

            // Lấy tên người duyệt từ OIDC profile
            const currentUser = await getUser();
            const nguoiDuyetName = currentUser?.profile?.preferred_username || "unknown";

            const payload = {
                id: duyetData?.id || duyetData?.Id,
                fieldName: 'XacNhanDuyet',
                value: status ? "Phù hợp" : "Không phù hợp",
                ngayDuyet: new Date().toISOString(),
                nguoiDuyet: nguoiDuyetName
            };

            await Put(`${DANHSACH_DUYET_HOSO_API.UPDATE_FIELD}`, null, payload);

            if (status === false && reason) {
                await Put(`${DANHSACH_DUYET_HOSO_API.UPDATE_FIELD}`, null, { id: duyetData?.id, fieldName: 'LyDo', value: reason, ngayDuyet: new Date().toISOString(), nguoiDuyet: nguoiDuyetName });
            }

            executeXacNhanPhuHop(itemId, status);
            toast.success("Xác nhận hồ sơ thành công!");
            queryClient.invalidateQueries(['giayPhepHanhNgheProfile']);

        } catch (error) {
            console.error("Lỗi:", error);
            toast.error("Không thể cập nhật. Thử lại!");
        } finally {
            setHoSoModal({ show: false, itemId: null, status: null, reason: '' });
        }
    };

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                <Spinner animation="border" variant="primary" />
                <span className="ms-2 text-muted">Đang tải dữ liệu...</span>
            </div>
        );
    }

    const isAdmin = userRole.includes(role.Admin);
    const hasBaseAccess = userRole.includes(role.APP_DANHSACHDUYETHOSO_ACCESS);

    const canViewHLDT = isAdmin || (hasBaseAccess && userRole.includes(role.HLDT_NHAN_VIEN));
    const canViewKHTH = isAdmin || (hasBaseAccess && userRole.includes(role.PHONG_KE_HOACH_TONG_HOP));

    const hasAccess = isAdmin || canViewHLDT || canViewKHTH;

    if (!hasAccess) {
        return (
            <div className="container-fluid mt-5">
                <Card className="text-center p-5 shadow-sm border-0 mx-auto" style={{ maxWidth: '600px' }}>
                    <Card.Body>
                        <i className="fas fa-lock text-danger mb-3" style={{ fontSize: '4rem' }}></i>
                        <h4 className="text-danger fw-bold mt-2">Truy cập bị từ chối</h4>
                        <p className="text-muted">Bạn không có quyền truy cập vào trang này. Yêu cầu quyền <strong>app_danhsachduyethoso_access</strong>.</p>
                        <Button variant="outline-secondary" onClick={() => window.history.back()}>
                            <i className="fas fa-arrow-left me-2"></i> Quay lại
                        </Button>
                    </Card.Body>
                </Card>
            </div>
        );
    }

    const renderTable = (cccmField, permissions = { readOnlyCchn: false, readOnlyCccm: false, readOnlyHoSo: false }) => (
        <Table responsive hover bordered striped className="mb-0 text-center">
            <thead className="bg-light">
                <tr className="align-middle">
                    <th>STT</th>
                    <th>Họ tên</th>
                    <th>Chức danh chuyên môn</th>
                    <th>Chức danh đang hoạt động</th>
                    <th>Đơn vị</th>
                    <th style={{ minWidth: '250px' }}>Phạm vi hành nghề</th>
                    <th style={{ minWidth: '220px' }}>Chứng chỉ hành nghề</th>
                    <th style={{ minWidth: '350px' }}>Văn bằng, chứng chỉ chuyên khoa</th>
                    <th style={{ minWidth: '100px' }}>Xác nhận phạm vi hành nghề</th>
                </tr>
            </thead>
            <tbody>
                {currentItems.length > 0 ? (
                    currentItems.map((item, index) => (
                        <tr key={item.id} className="align-middle">
                            <td className="align-middle text-center">{indexOfFirstItem + index + 1}</td>
                            <td className="text-start fw-bold align-middle">{item.ten}</td>
                            <td className="align-middle">{item.chucDanhChuyenMon}</td>
                            <td className="align-middle">{item.doiTuong}</td>
                            <td className="align-middle">{item.donVi}</td>

                            <td className="text-start align-middle">
                                {item.phamViHanhNghe && item.phamViHanhNghe.length > 0 ? (
                                    item.phamViHanhNghe.map((pv, idx) => (
                                        <div key={idx}>{pv}</div>
                                    ))
                                ) : (
                                    <span className="text-muted fst-italic">-</span>
                                )}
                            </td>

                            <td className="align-middle">
                                <div className="d-flex justify-content-between align-items-center text-start">
                                    <div>
                                        <div className="fw-bold mb-1">
                                            {item.fileUrl ? (
                                                <span onClick={(e) => handleViewFile(item.fileUrl, e)} title="Click để xem file" className="text-primary text-decoration-underline file-link" style={{ cursor: 'pointer' }}>
                                                    {item.cchn} <i className="fas fa-external-link-alt ms-1" style={{ fontSize: '0.8em' }}></i>
                                                </span>
                                            ) : (
                                                <span className="text-dark">{item.cchn}</span>
                                            )}
                                        </div>
                                        <div className="text-muted" style={{ fontSize: '12px' }}>
                                            {item.moTaCchn?.map((line, idx) => <div key={idx}>{line}</div>)}
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center ms-2 flex-shrink-0" style={{ gap: '4px' }}>
                                        {permissions.readOnlyCchn ? (
                                            <div>{renderStatusBadge(item.cchnStatus, 'duyet')}</div>
                                        ) : (
                                            <>
                                                <Button size="sm" variant={item.cchnStatus === true ? 'success' : 'outline-success'} onClick={() => openConfirmModal('CCHN', item.id, null, true)} title="Duyệt" className="btn-icon">
                                                    <i className="fas fa-check"></i>
                                                </Button>
                                                <Button size="sm" variant={item.cchnStatus === false ? 'danger' : 'outline-danger'} onClick={() => openConfirmModal('CCHN', item.id, null, false)} title="Từ chối" className="btn-icon">
                                                    <i className="fas fa-times"></i>
                                                </Button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </td>

                            <td className="align-middle">
                                {item[cccmField] && item[cccmField].length > 0 ? (
                                    item[cccmField].map((cert, certIdx) => (
                                        <div key={cert.idCccm} className={`d-flex justify-content-between align-items-center text-start ${certIdx !== item[cccmField].length - 1 ? 'border-bottom pb-2 mb-2' : ''}`}>
                                            <div className="d-flex flex-column align-items-start" style={{ wordBreak: 'break-word', whiteSpace: 'normal', paddingRight: '10px' }}>
                                                <div className="fw-bold mb-1">
                                                    {cert.loaiCccm && (
                                                        <div className="mb-1">
                                                            <span className="badge bg-success" style={{ fontWeight: '500', padding: '4px 8px', letterSpacing: '0.3px' }}>
                                                                {getShortLoaiChungChi(cert.loaiCccm)}
                                                            </span>
                                                        </div>
                                                    )}
                                                    {cert.fileUrl ? (
                                                        <span onClick={(e) => handleViewFile(cert.fileUrl, e)} title="Click để xem file" className="text-primary text-decoration-underline file-link" style={{ cursor: 'pointer' }}>
                                                            {cert.tenCccm} <i className="fas fa-external-link-alt ms-1" style={{ fontSize: '0.8em' }}></i>
                                                        </span>
                                                    ) : (
                                                        <span className="text-dark">{cert.tenCccm}</span>
                                                    )}
                                                </div>
                                                {cert.ghiChu && (
                                                    <div className="text-muted fw-normal mt-1" style={{ fontSize: '12.5px', fontStyle: 'italic', display: 'block' }}>
                                                        ({cert.ghiChu})
                                                    </div>
                                                )}
                                            </div>
                                            <div className="d-flex align-items-center ms-2 flex-shrink-0" style={{ gap: '4px' }}>
                                                {permissions.readOnlyCccm ? (
                                                    <div>{renderStatusBadge(cert.status, 'duyet')}</div>
                                                ) : (
                                                    <>
                                                        <Button size="sm" variant={cert.status === true ? 'success' : 'outline-success'} onClick={() => openConfirmModal('CCCM', item.id, cert.idCccm, true)} title="Duyệt" className="btn-icon">
                                                            <i className="fas fa-check"></i>
                                                        </Button>
                                                        <Button size="sm" variant={cert.status === false ? 'danger' : 'outline-danger'} onClick={() => openConfirmModal('CCCM', item.id, cert.idCccm, false)} title="Từ chối" className="btn-icon">
                                                            <i className="fas fa-times"></i>
                                                        </Button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-muted fst-italic" style={{ fontSize: '13px' }}>Không có chứng chỉ loại này</div>
                                )}
                            </td>

                            <td className="align-middle text-center">
                                {permissions.readOnlyHoSo ? (
                                    <div>{renderStatusBadge(item.xacNhanStatus, 'hoso')}</div>
                                ) : (
                                    <div className="d-flex align-items-center justify-content-center" style={{ gap: '4px' }}>
                                        <Button size="sm" variant={item.xacNhanStatus === true ? "success" : "outline-success"} onClick={() => setHoSoModal({ show: true, itemId: item.id, status: true, reason: '' })} title="Xác nhận Phù hợp" className="btn-icon">
                                            <i className="fas fa-check"></i>
                                        </Button>
                                        <Button size="sm" variant={item.xacNhanStatus === false ? "danger" : "outline-danger"} onClick={() => setRejectModal({ show: true, itemId: item.id, reason: '', customReason: '' })} title="Xác nhận Không phù hợp" className="btn-icon">
                                            <i className="fas fa-times"></i>
                                        </Button>
                                    </div>
                                )}
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr><td colSpan="9" className="text-center py-4 text-muted">Không tìm thấy dữ liệu phù hợp với bộ lọc</td></tr>
                )}
            </tbody>
        </Table>
    );

    return (
        <>

            <style>
                {`
                    .modal-backdrop.show { z-index: 1040 !important; }
                    .modal.show { z-index: 1055 !important; }
                    .file-link:hover { opacity: 0.8; }
                    .btn-icon { width: 32px; height: 32px; padding: 0; display: inline-flex; align-items: center; justify-content: center; }
                `}
            </style>


            <div className="container-fluid mt-3">
                <Card>

                    <Card.Body className="p-3">

                        <div className="d-flex flex-wrap justify-content-between align-items-end mb-3" style={{ gap: '15px' }}>
                            {/* <div className="d-flex flex-column">
                                <span className="text-muted fw-medium mb-1" style={{ fontSize: '13px' }}>Hiển thị dòng:</span>
                                <Form.Control as="select" size="sm" value={itemsPerPage} onChange={handleItemsPerPageChange} style={{ minWidth: '80px', cursor: 'pointer' }}>
                                    <option value={5}>5 dòng</option>
                                    <option value={10}>10 dòng</option>
                                    <option value={20}>20 dòng</option>
                                    <option value={50}>50 dòng</option>
                                    <option value={999999}>Tất cả</option>
                                </Form.Control>
                            </div> */}
                            <div className="d-flex flex-wrap align-items-center justify-content-end ms-auto" style={{ gap: '15px' }}>
                                {/* INPUT TÌM KIẾM THEO TÊN */}
                                <div className="d-flex flex-column">
                                    <span className="text-muted fw-medium mb-1" style={{ fontSize: '13px' }}>Tìm theo Tên:</span>
                                    <div className="d-flex">
                                        <Form.Control
                                            type="text"
                                            size="sm"
                                            placeholder="Nhập Tên..."
                                            value={searchNameInput}
                                            onChange={(e) => setSearchNameInput(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    setSearchName(searchNameInput);
                                                    setCurrentPage(1);
                                                }
                                            }}
                                            style={{ minWidth: '150px' }}
                                        />
                                        <Button
                                            size="sm"
                                            variant="primary"
                                            className="ms-1 d-flex align-items-center justify-content-center"
                                            onClick={() => {
                                                setSearchName(searchNameInput);
                                                setCurrentPage(1);
                                            }}
                                        >
                                            <i className="fas fa-search"></i>
                                        </Button>
                                    </div>
                                </div>
                                {/* INPUT TÌM KIẾM CCCD ĐƯỢC THÊM VÀO ĐÂY */}
                                <div className="d-flex flex-column">
                                    <span className="text-muted fw-medium mb-1" style={{ fontSize: '13px' }}>Tìm theo CCCD:</span>
                                    <div className="d-flex">
                                        <Form.Control
                                            type="text"
                                            size="sm"
                                            placeholder="Nhập CCCD..."
                                            value={searchCccdInput}
                                            onChange={(e) => setSearchCccdInput(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    setSearchCccd(searchCccdInput);
                                                    setCurrentPage(1);
                                                }
                                            }}
                                            style={{ minWidth: '150px' }}
                                        />
                                        <Button
                                            size="sm"
                                            variant="primary"
                                            className="ms-1 d-flex align-items-center justify-content-center"
                                            onClick={() => {
                                                setSearchCccd(searchCccdInput);
                                                setCurrentPage(1);
                                            }}
                                        >
                                            <i className="fas fa-search"></i>
                                        </Button>
                                    </div>
                                </div>
                                <div className="d-flex flex-column">
                                    <span className="text-muted fw-medium mb-1" style={{ fontSize: '13px' }}>Đơn vị:</span>
                                    <div style={{ minWidth: '250px' }}>
                                        <Select
                                            options={donViOptions}
                                            value={filterDonVi ? { value: filterDonVi, label: filterDonVi } : null}
                                            onChange={(opt) => { setFilterDonVi(opt ? opt.value : ''); setCurrentPage(1); }}
                                            placeholder="-- Tất cả đơn vị --"
                                            isClearable
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    borderRadius: 6,
                                                    fontSize: '0.875rem',
                                                    border: '1px solid #dee2e6',
                                                    boxShadow: 'none',
                                                    minHeight: '31px',
                                                    '&:hover': { border: '1px solid #ced4da' }
                                                }),
                                                menu: (base) => ({ ...base, fontSize: '0.875rem', zIndex: 999 }),
                                                valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                                                indicatorsContainer: (base) => ({ ...base, height: '31px' })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="d-flex flex-column">
                                    <span className="text-muted fw-medium mb-1" style={{ fontSize: '13px' }}>Chức danh đang hoạt động:</span>
                                    <div style={{ minWidth: '200px' }}>
                                        <Select
                                            options={doiTuongOptions}
                                            value={filterDoiTuong ? { value: filterDoiTuong, label: filterDoiTuong } : null}
                                            onChange={(opt) => { setFilterDoiTuong(opt ? opt.value : ''); setCurrentPage(1); }}
                                            placeholder="-- Tất cả chức danh --"
                                            isClearable
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    borderRadius: 6,
                                                    fontSize: '0.875rem',
                                                    border: '1px solid #dee2e6',
                                                    boxShadow: 'none',
                                                    minHeight: '31px',
                                                    '&:hover': { border: '1px solid #ced4da' }
                                                }),
                                                menu: (base) => ({ ...base, fontSize: '0.875rem', zIndex: 999 }),
                                                valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                                                indicatorsContainer: (base) => ({ ...base, height: '31px' })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="d-flex flex-column">
                                    <span className="text-muted fw-medium mb-1" style={{ fontSize: '13px' }}>Trạng thái xác nhận:</span>
                                    <div style={{ minWidth: '180px' }}>
                                        <Select
                                            options={[
                                                { value: 'phu_hop', label: 'Phù hợp' },
                                                { value: 'khong_phu_hop', label: 'Không phù hợp' },
                                                { value: 'chua_xac_nhan', label: 'Chưa xác nhận' }
                                            ]}
                                            value={filterXacNhan && filterXacNhan !== 'all' ? { value: filterXacNhan, label: filterXacNhan === 'phu_hop' ? 'Phù hợp' : (filterXacNhan === 'khong_phu_hop' ? 'Không phù hợp' : 'Chưa xác nhận') } : null}
                                            onChange={(opt) => { setFilterXacNhan(opt ? opt.value : 'all'); setCurrentPage(1); }}
                                            placeholder="-- Tất cả --"
                                            isClearable
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    borderRadius: 6,
                                                    fontSize: '0.875rem',
                                                    border: '1px solid #dee2e6',
                                                    boxShadow: 'none',
                                                    minHeight: '31px',
                                                    '&:hover': { border: '1px solid #ced4da' }
                                                }),
                                                menu: (base) => ({ ...base, fontSize: '0.875rem', zIndex: 999 }),
                                                valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                                                indicatorsContainer: (base) => ({ ...base, height: '31px' })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="mt-3">
                            {renderTable('cccmKHTH', { readOnlyCchn: true, readOnlyCccm: true, readOnlyHoSo: false })}
                        </div>


                        {filteredDanhSach.length > 0 && (
                            <div className="d-flex flex-wrap justify-content-between align-items-center mt-3 p-2 bg-light rounded border border-top-0" style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
                                <div className="text-muted fw-medium" style={{ fontSize: '14px' }}>
                                    Hiển thị từ <span className="text-dark fw-bold">{indexOfFirstItem + 1}</span> đến <span className="text-dark fw-bold">{Math.min(indexOfLastItem, totalRecords)}</span> trong tổng số <span className="text-primary fw-bold">{totalRecords}</span> hồ sơ
                                </div>
                                {totalPages > 1 && (
                                    <div
                                        className="dataTables_paginate paging_simple_numbers"
                                        id="example2_paginate"
                                    >
                                        <Pagination
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            innerClass="pagination pagination-sm no-margin pull-right"
                                            activePage={currentPage}
                                            itemsCountPerPage={Number(
                                                itemsPerPage
                                            )}
                                            totalItemsCount={totalRecords}
                                            pageRangeDisplayed={5}
                                            onChange={(number) =>
                                                paginate(number)
                                            }
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                    </Card.Body>
                </Card>
            </div>

            <Modal show={rejectModal.show} onHide={() => setRejectModal({ show: false, itemId: null, reason: '', customReason: '' })} centered backdrop="static">
                <Modal.Header closeButton className="border-bottom-0 pb-0">
                    <Modal.Title className="fs-5 fw-bold text-danger"><i className="fas fa-exclamation-triangle me-2"></i> Lý do không phù hợp</Modal.Title>
                </Modal.Header>
                <Modal.Body className="fs-6 py-4">
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-medium">Chọn lý do <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            as="select"
                            value={rejectModal.reason}
                            onChange={(e) => setRejectModal({ ...rejectModal, reason: e.target.value })}
                            className="form-control"
                        >
                            <option value="">-- Vui lòng chọn lý do --</option>
                            {REJECT_REASONS.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
                        </Form.Control>
                    </Form.Group>

                    {rejectModal.reason === 'Khác' && (
                        <Form.Group className="mb-0 mt-3">
                            <Form.Label className="fw-medium">Nhập lý do khác <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Vui lòng nhập lý do cụ thể..."
                                value={rejectModal.customReason}
                                onChange={(e) => setRejectModal({ ...rejectModal, customReason: e.target.value })}
                            />
                        </Form.Group>
                    )}
                </Modal.Body>
                <Modal.Footer className="border-top-0 pt-0">
                    <Button variant="light" onClick={() => setRejectModal({ show: false, itemId: null, reason: '', customReason: '' })} className="fw-medium px-4 border">Hủy</Button>
                    <Button
                        variant="primary"
                        className="fw-medium px-4"
                        disabled={!rejectModal.reason || (rejectModal.reason === 'Khác' && !rejectModal.customReason.trim())}
                        onClick={() => {
                            const finalReason = rejectModal.reason === 'Khác' ? rejectModal.customReason : rejectModal.reason;
                            setRejectModal({ show: false, itemId: null, reason: '', customReason: '' });
                            setHoSoModal({ show: true, itemId: rejectModal.itemId, status: false, reason: finalReason });
                        }}
                    >
                        Tiếp tục
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={hoSoModal.show} onHide={() => setHoSoModal({ show: false, itemId: null, status: null, reason: '' })} centered backdrop="static">
                <Modal.Header closeButton className="border-bottom-0 pb-0">
                    <Modal.Title className="fs-5 fw-bold text-primary"><i className="fas fa-info-circle me-2 text-info"></i> Xác nhận trạng thái</Modal.Title>
                </Modal.Header>
                <Modal.Body className="fs-6 py-4 text-dark">
                    Bạn có chắc chắn muốn xác nhận toàn bộ hồ sơ này là <strong className={hoSoModal.status ? "text-success" : "text-danger"}>{hoSoModal.status ? 'PHÙ HỢP' : 'KHÔNG PHÙ HỢP'}</strong>?

                    {hoSoModal.status === false && hoSoModal.reason && (
                        <div className="mt-3 p-3 bg-light rounded border">
                            <span className="fw-bold">Lý do:</span> <span className="text-danger fst-italic">{hoSoModal.reason}</span>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="border-top-0 pt-0">
                    <Button variant="light" onClick={() => setHoSoModal({ show: false, itemId: null, status: null, reason: '' })} className="fw-medium px-4 border">Hủy</Button>
                    <Button variant={hoSoModal.status ? "success" : "danger"} onClick={xacNhanHoSoConfirm} className="fw-medium px-4">Đồng ý</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered backdrop="static" keyboard={false}>
                <Modal.Header closeButton className="border-bottom-0 pb-0">
                    <Modal.Title className="fs-5 fw-bold text-primary"><i className="fas fa-exclamation-circle me-2 text-warning"></i> Xác nhận thao tác</Modal.Title>
                </Modal.Header>
                <Modal.Body className="fs-6 py-4 text-dark">{getConfirmMessage()}</Modal.Body>
                <Modal.Footer className="border-top-0 pt-0">
                    <Button variant="light" onClick={() => setShowConfirmModal(false)} className="fw-medium px-4 border">Hủy</Button>
                    <Button variant={pendingAction && pendingAction.status === false ? "danger" : "primary"} onClick={handleConfirmAction} className="fw-medium px-4">Đồng ý</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DanhSachDuyetHoSoKHTH;
